import React, { useEffect, useState } from 'react';
import VantageLogo from '@/assets/images/vantageAI.png';
import DesignImage from '@/assets/images/redirectscreenimage-removebg-preview.png';
import { Button, Spin } from 'antd';
import { Loading3QuartersOutlined } from '@ant-design/icons';
import { MdLock } from 'react-icons/md';
import { useLocation } from 'react-router';
import { useMultiTabsContext } from '@/layouts/dashboard/multi-tabs/providers/multi-tabs-provider';
const PaymentGatewayRedirectScreen = () => {
  const [count, setCount] = useState(6);
  const location = useLocation();
  const {
    payment_url
  } = location?.state || {};
  const {} = useMultiTabsContext();
  useEffect(() => {
    if (count === 0) {
      window.location.href = payment_url;
      return;
    }
    const interval = setTimeout(() => {
      if (count > 0) {
        setCount(prev => prev - 1);
      }
    }, 1000);
    return () => clearTimeout(interval);
  }, [count, payment_url]);
  const handleContinue = () => {
    window.location.href = payment_url;
  };
  return <div className='w-full h-screen flex flex-col items-center justify-center pb-32 bg-[#F8FAFC] dark:bg-[#020617]'>

      {/* Logo */}
      <img src={VantageLogo} alt="vantageAI-logo" className='w-[200px] h-[200px] object-contain' />

      {/* Image */}
      <img src={DesignImage} alt="DesignImage" className='w-[350px] h-[350px] object-contain -mt-32' />

      <h1 className='text-2xl font-bold text-black dark:text-white -mt-20'>Redirecting to Secure Payment</h1>
      <span className='mt-3 w-[360px] text-center text-gray-600 dark:text-gray-400 font-medium'>You will be redirected to our secure payment partner
to complete your payment.</span>

        <Spin size='large' className='text-[#C41230]' style={{
      marginTop: "30px"
    }} indicator={<Loading3QuartersOutlined spin />} />

        <span className='mt-4 font-medium text-gray-500 dark:text-gray-400'>Redirecting in {count} seconds ...</span>

        <span className='mt-3 font-medium text-gray-500 dark:text-gray-400'>If you are not redirected automatically, click the button below.</span>

        <Button size='large' className='mt-6 bg-transparent hover:!bg-[#C41230]/10 dark:hover:!bg-[#C41230]/20' style={{
      color: "#C41230",
      borderColor: "#C41230",
      fontWeight: "bold",
      fontSize: "16px",
      paddingLeft: "20px",
      paddingRight: "20px"
    }} onClick={handleContinue}>Continue to Payment</Button>

        <div className='flex items-center gap-2 mt-10'>
          <MdLock className='text-gray-500 dark:text-gray-400' />
          <span className='text-gray-500 dark:text-gray-400 font-medium'>Secure payment powered by our trusted partner</span>
        </div>

    </div>;
};
export default PaymentGatewayRedirectScreen;